import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '../router'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    session: {},
    user: {},
    dypId: process.env.VUE_APP_CURRENT_DYP_ID,
    baseEccoUrl: process.env.VUE_APP_BASE_ECCO_URL,
    baseUrl: process.env.VUE_APP_BASE_URL,
    state: '39fh03fhj30gh0jfowej0fifjasodin0jhkg2',
    clientId: process.env.VUE_APP_CLIENT_ID,
    redirectUri: process.env.VUE_APP_REDIRECT_URI,
    marianaTekUri: process.env.VUE_APP_MARIANA_TEK_URI,
    marianaBaseUri: process.env.VUE_APP_BASE_MARIANA_URI,
    prompt: 0,
    signupError: null,
    locations: [],
    locationsLoading: false,
    ref: null,

    stripeProductId: process.env.VUE_APP_DYP_DONATION_STRIPE_ID,
    stripeProductPrice: process.env.VUE_APP_DYP_DONATION_STRIPE_PRICE,

    member: null,
    team: null,
    teams: null,
    charities: null,
    charitiesLoading: false,
    stripeCheckout: null,
    memberLeaderboard: null,
    memberLeaderboardLoading: false,
    startDate: process.env.VUE_APP_DYP_START_DATE,
    endDate: process.env.VUE_APP_DYP_END_DATE,
  },

  mutations: {
    setSession: (state, val) => {
      state.session = val
    },
    setUser: (state, val) => {
      state.user = val
    },
    setLocations: (state, val) => {
      state.locations = val
    },
    setLocationsLoading: (state, val) => {
      state.locationsLoading = val
    },
    setMember: (state, val) => {
      state.member = val
    },
    setTeam: (state, val) => {
      state.team = val
    },
    setTeams: (state, val) => {
      state.teams = val
    },
    setCharities: (state, val) => {
      state.charities = val
    },
    setCharitiesLoading: (state, val) => {
      state.charitiesLoading = val
    },
    setStripeCheckout: (state, val) => {
      state.stripeCheckout = val
    },
    setMemberLeaderboard: (state, val) => {
      state.memberLeaderboard = val
    },
    setMemberLeaderboardLoading: (state, val) => {
      state.memberLeaderboardLoading = val
    }
  },

  actions: {
    createAccount: ({ dispatch, commit, state }, data) => {
      axios.post(`${state.baseUrl}/me/account`, data).then((res) => {
        dispatch('signupAuthenticate', res.headers['x-ephemeral-token'])
        commit('setUser', res.data)
      }).catch((err) => {
        console.log(err.response)
        if (err.response.data?.email?.length > 0) {
          state.signupError = err.response.data.email[0]
        }
      })
    },

    authenticate: async ({ commit, dispatch, state }) => {
      axios.post(`${state.marianaBaseUri}/o/token/?client_id=${state.clientId}&code_verifier=${state.challenge}&code=${state.code}&grant_type=authorization_code&redirect_uri=${state.redirectUri}`)
      .then(async (data) => {
        commit('setSession', data.data)
        await dispatch('getProfile')
      })
      .catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
        console.log(error.config);
      });
    },

    signupAuthenticate: ({ state }, data) => {
      window.location.href = `${state.marianaBaseUri}/o/authorize?response_type=code&client_id=${state.clientId}&redirect_uri=${state.redirectUri}&code_challenge=${state.challenge}&ephemeral_token=${data}`
    },

    getLocations: ({ commit, state }) => {
      commit('setLocationsLoading', true)
      axios.get(`${state.baseEccoUrl}/mariana/location`).then((res) => {
        commit('setLocations', res.data.data)
        commit('setLocationsLoading', false)
      }).catch((err) => {
        console.log(err.response)
        commit('setLocationsLoading', false)
      })
    },

    getProfile: async ({ commit, dispatch, state }) => {
      return new Promise((resolve, reject) => {
        axios.get(`${state.baseUrl}/me/account`, {
          headers: {
            'Authorization': `Bearer ${state.session.access_token}`
          }
        }).then(async (res) => {
          commit('setUser', res.data)
          dispatch('checkForMember')
          resolve('user set')
        }).catch((err) => {
          console.log(err.response)
          reject('error getting profile')
        })
      })
    },

    getCharities: async ({ commit, state }) => {
      return new Promise((resolve, reject) => {
        commit('setCharitiesLoading', true)
        axios.get(`${state.baseEccoUrl}/dyp/charity?dypId=${state.dypId}`)
          .then(res => {
            commit('setCharities', res.data)
            commit('setCharitiesLoading', false)
            resolve(res.data)
          })
          .catch(err => {
            console.log(err)
            commit('setCharitiesLoading', false)
            reject('Failed to get charities.')
          })
      })
    },

    createMember: async ({ commit, state }, data) => {
      return new Promise((resolve, reject) => {
        axios.post(`${state.baseEccoUrl}/dyp/member`, data)
          .then(res => {
            commit('setMember', res.data)
            resolve('challenge created')
          })
          .catch(err => {
            console.log(err)
            reject('error creating challenge')
          })
      })
    },

    patchMemberHasPaid: async ({ commit, state }, id) => {
      return new Promise((resolve, reject) => {
        axios.patch(`${state.baseEccoUrl}/dyp/member/${id}`, {
            hasPaid: true,
          })
          .then(res => {
            commit('setMember', res.data)
            resolve('member has paid')
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },

    checkForMember: async ({ commit, state }) => {
      return new Promise((resolve, reject) => {
        axios.get(`${state.baseEccoUrl}/dyp/member?marianaTekId=${state.user.id}&dypId=${state.dypId}`)
          .then((res) => {
            if (res.data.total > 0) {
              commit('setMember', res.data.data[0])
              if (state.member.hasPaid) {
                router.push('/leaderboard')
              } else {
                router.push('/join')
              }
              resolve(true)
            } else {
              router.push('/join')
            }
          })
          .catch(err => {
            console.log(err)
            reject('error retrieving member')
          })
      })
    },

    createTeam: async ({ commit, state }, data) => {
      return new Promise((resolve, reject) => {
        axios.post(`${state.baseEccoUrl}/dyp/team`, data)
          .then(res => {
            commit('setTeam', res.data)
            resolve('Team fetched.')
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },

    getTeams: async({ commit, state}) => {
      return new Promise((resolve, reject) => {
        axios.get(`${state.baseEccoUrl}/dyp/team?dypId=${state.dypId}`)
          .then(res => {
            commit('setTeams', res.data)
            resolve('Teams fetched.')
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    
    createStripeCheckout: async({ commit, state }, data) => {
      return new Promise((resolve, reject) => {
        axios.post(`${state.baseEccoUrl}/stripe/checkout`, data)
          .then(res => {
            commit('setStripeCheckout', res.data)
            resolve(res.data)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },

    getMemberLeaderboard: async({ commit, state }, charityId) => {
      commit('setMemberLeaderboardLoading', true)
      return new Promise((resolve, reject) => {
        axios.get(`${state.baseEccoUrl}/dyp/member`, {
          params: {
            dypId: state.dypId,
            charityId,
            hasPaid: true,
            $limit: 1000,
          }
        })
          .then(res => {
            commit('setMemberLeaderboard', res.data.data)
            commit('setMemberLeaderboardLoading', false)
            resolve('Leaderboard fetched.')
          })
          .catch(err => {
            console.log(err)
            commit('setMemberLeaderboardLoading', false)
            reject(err)
          })
      })
    }
  },

  getters: {
    isAuthenticated(state) {
      return (state.session.access_token && state.session.access_token.length > 0)
    },
    hasSignedUp(state) {
      return (state.member && state.member.id)
    },
    hasPaid(state) {
      return (state.member && state.member.id && state.member.hasPaid)
    }
  },

  modules: {
  },
  plugins: [createPersistedState({
    paths: [
      'session',
      'user',
      'state',
      'ref',
      'member',
    ]
  })],
})
